import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Button,
  Container,
  Icon,
  List,
  ListItem,
  Modal,
  ListHeader,
  ListContent,
  ModalActions,
  ModalContent,
  ModalHeader,
  Step,
  Image,
  Input,
} from "semantic-ui-react";

import BarcodeInput from "../BarcodeInput/BarcodeInput";

import styles from "./SwapBoxModal.module.css";
import useInput from "../../../hooks/useInput";
import { conveyorBoxEndpoints } from "../../../lib/conveyorbox/endpoints";
import SkuEndpoints from "../../../lib/sku/SkuEndpoints";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  items: any[];
  barcode: string;
};

const WeightUpdate = ({value, barcode} : {value: number, barcode: string}) => {
    const [weight, setWeight] = useState("")
    return <> Ange uppmätt vikt i gram: <Input value={weight} onChange={(e) => setWeight(e.target.value)} numerical />
                        <Button style={{marginLeft: "10px"}}
                                    primary
                                    
                                    onClick={async () => {
                                        try{
                                            const w = parseInt(weight)
                                            await conveyorBoxEndpoints.setWeightOnSku(barcode, 9072, value, w)
                                            window.alert("Artikelns data har uppdaterats, du kan lägga tillbaka artikeln på bandet.")
                                        }catch (e: any){
                                            window.alert(e?.message ? e.message : "Något gick fel.")
                                        }
                                    }}
                                  >
                                    Uppdatera vikt
                                  </Button></>
}

const ChangeWeightModal = ({
  isOpen,
  onClose,
  items,
  barcode
}: Props) => {
  

  return (
    <Modal dimmer="blurring" open={isOpen} size="small">
      <ModalHeader>Ändra vikt på artiklar</ModalHeader>
      <ModalContent>
        <List divided relaxed size="large" style={{ maxHeight: "400px", overflow: "auto" }}>
            {items.map((item) => {
                  const id = item.id
                  const article = item.article;
                  
                  return (
                    <ListItem
                      key={id}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        overflow: "hidden",
                        padding: "8px",
                        borderRadius: "5px",
                      }}
                    >
                      <Image avatar src={article.imageUrl} />
                      <ListContent verticalAlign="middle" style={{ flex: "1", minWidth: "0" }}>
                        <ListHeader
                          as="p"
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "block",
                          }}
                        >
                          {` ${article.name} (${article.weight}g).`}
                          
                        </ListHeader>
                       <WeightUpdate barcode={barcode} value={item.sku.id}/>
                      </ListContent>
                    </ListItem>
                  )
            })}
        </List>
      </ModalContent>
      <ModalActions>
      
                <Button negative onClick={onClose}>
                  Avbryt
                </Button>
      </ModalActions>
    </Modal>
  );
};

export default ChangeWeightModal;
